import React, { useEffect } from 'react'
import get from 'lodash/get'
import size from 'lodash/size'
import round from 'lodash/round'
import './style.scss'
import { statusSignal, checkCpfStatus, statusLabelSignal, checkLabelCpfStatus } from './rules'
import ScoreRow from './components/ScoreRow'
import ProgressRing from './components/ProgressRing'

const CreditScreenView = ({ handleScoreCreditCardInfo, infoScore }) => {
  const useMountEffect = (fun) => useEffect(fun, [])

  useMountEffect(handleScoreCreditCardInfo)

  const classScoreMap = {
    A: 5,
    B: 4,
    C: 3,
    D: 2,
    E: 1,
    F: 0,
  }

  return (
    <div>
      <div className='review_header'>
        <div className='review_text'>
          Nome do Interessado: <br /> {get(infoScore, 'summary.consultedName')}
        </div>
        <div className='review_text'>CPF: {get(infoScore, 'consulted_cpf')}</div>
      </div>

      <div className='review'>
        <div
          className='review_status'
          style={statusSignal(size(get(infoScore, 'summary.financialPendencies')))}
        >
          <input
            syle={statusLabelSignal(size(get(infoScore, 'summary.financialPendencies')))}
            className='review_status_input'
            disabled
            value={size(get(infoScore, 'summary.financialPendencies'))}
            type='text'
          />
          <div className='review_status_text'>Pendências Financeiras</div>
        </div>
        <div className='review_status' style={statusSignal(get(infoScore, 'summary.comercialPendencies'))}>
          <input
            style={statusLabelSignal(size(get(infoScore, 'comercialPendencies')))}
            className='review_status_input'
            disabled
            value={size(get(infoScore, 'comercialPendencies'))}
            type='text'
          />
          <div className='review_status_text'>Pendências Comerciais</div>
        </div>
        <div className='review_status' style={statusSignal(get(infoScore, 'summary.protests'))}>
          <input
            style={statusLabelSignal(size(get(infoScore, 'summary.protests')))}
            className='review_status_input'
            disabled
            value={get(infoScore, 'summary.protests')}
            type='text'
          />
          <div className='review_status_text'>Protestos</div>
        </div>
        <div className='review_status' style={statusSignal(get(infoScore, 'summary.badChecks'))}>
          <input
            style={statusLabelSignal(get(infoScore, 'summary.badChecks'))}
            className='review_status_input'
            disabled
            value={get(infoScore, 'summary.badChecks')}
            type='text'
          />
          <div className='review_status_text'>
            Cheques
            <br />
            (Sem fundos)
          </div>
        </div>
      </div>

      <div>
        <ScoreRow title={'Score'} minValue={0} maxValue={1000} value={get(infoScore, 'summary.score', 330)} />
        <div className='review_type_divisor' />
        <ScoreRow
          title={'Classe Score 12 meses'}
          minValue={0}
          maxValue={5}
          minLabel='F'
          maxLabel='A'
          value={classScoreMap[get(infoScore, 'summary.class', 'F')]}
          valueLabel={get(infoScore, 'summary.class', 'F')}
        />
        <div className='review_type_divisor' />
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div className='review_type_name'>Possibilidade de inadiplência</div>
          <div style={{ marginLeft: 'auto', flex: 1, alignSelf: 'flex-end' }}>
            <ProgressRing progress={round(get(infoScore, 'summary.defaultProbability', 0), 2)} />
          </div>
        </div>
        <div className='review_type_divisor' />
        <div className='review_type'>
          <div className='review_type_name'>Situação do CPF</div>
          <div className='review_type_value'>
            <div className='review_type_status' style={checkCpfStatus(get(infoScore, 'summary.cpfStatus'))}>
              <input
                maxLength='1'
                size='1'
                min='0'
                max='9'
                pattern='[0-9]{1}'
                style={checkLabelCpfStatus(get(infoScore, 'summary.cpfStatus'))}
                disabled
                className='review_status_input'
                value={get(infoScore, 'summary.cpfStatus')}
                type='text'
              />
            </div>
          </div>
        </div>
        <div className='review_type_divisor' />
      </div>

      <div className='review_accept'>
        <div className='review_accept_header'>Obtenha a conferência</div>
        <div className='review_accept_subtitle'>Para conferir os dados de crédito de</div>
        <div className='review_accept_subtitle'>seu futuro morador!</div>
      </div>
    </div>
  )
}

// TODO: use ts
// CreditScreenView.propTypes = {
//   handleScoreCreditCardInfo: PropTypes.func,
//   infoScore: PropTypes.object,
// }

export default CreditScreenView
